module.exports = __webpack_public_path__ + "img/1ENG_Cover.af8782da.jpg";